import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { ActiveDocumentsComponent } from '../documents/active-documents/active-documents.component';
import { TotalStatComponent } from './total-stat/total-stat.component';
import { WelcomeMessageComponent } from './welcome-message/welcome-message.component';
import { ActiveDocumentCardComponent } from '../documents/active-documents/active-document-card/active-document-card.component';
import { ActiveDocumentDropdownMenuComponent } from '../documents/active-documents/active-document-dropdown-menu/active-document-dropdown-menu.component';
import { ActiveDocumentComponent } from '../documents/active-documents/active-document/active-document.component';

@NgModule({
  imports: [
    CommonModule,
    DashboardRoutingModule,
    NgxChartsModule,
    SharedModule,
  ],
  declarations: [
    ActiveDocumentComponent,
    ActiveDocumentCardComponent,
    ActiveDocumentDropdownMenuComponent,
    ActiveDocumentsComponent,
    DashboardComponent,
    TotalStatComponent,
    WelcomeMessageComponent,
  ],
})
export class DashboardModule {}
